import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'tax-success-window',
  templateUrl: 'success-window.component.html',
  styleUrls: ['success-window.component.sass'],
})
export class SuccessWindowComponent implements OnInit {
  TIME_TO_CLOSE = 5000;

  // @ts-ignore
  @Input() action: 'success-eds' | 'success-sms' | 'success-registration';
  @Input() isIndividual = false;
  @Output() closed: EventEmitter<void> = new EventEmitter();

  constructor() {}

  ngOnInit() {
    setTimeout(() => this.closed.emit(), this.TIME_TO_CLOSE);
  }
}
